import { render, staticRenderFns } from "./titulo.vue?vue&type=template&id=2ad7281b&scoped=true&"
import script from "./titulo.vue?vue&type=script&lang=js&"
export * from "./titulo.vue?vue&type=script&lang=js&"
import style0 from "./titulo.vue?vue&type=style&index=0&id=2ad7281b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7281b",
  null
  
)

export default component.exports